import { useState, useEffect } from "react";
import { Spin } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import MediaQuery from "react-responsive";

import { Types } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Icons from "scripts/icons";

import Map from "components/map";
import { connect } from "react-redux";

const Component = ({ user }) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const {
		bookmarked,
		address,
		avatar,
		category,
		ceo,
		city,
		cover,
		description,
		discount,
		instagramUrl,
		latitude,
		loaded,
		longitude,
		phoneNumbers,
		province,
		rating,
		title,
		websiteUrl,
		workTime,
	} = state;
	const navigate = useNavigate();
	const { id } = useParams();

	const bookmark = (id) => {
		API.job
			.bookmark(id)
			.then(({ bookmarked }) => {
				setState((prevState) => ({
					...prevState,
					bookmarked,
				}));
			})
			.catch(() => {});
	};

	const handleRating = (value) => {
		if (user.id) {
			API.job
				.rate(id, { score: value })
				.then(({ rating }) => {
					setState((prevState) => ({ ...prevState, rating }));
				})
				.catch(() => {});
		} else {
			navigate("/auth/status");
		}
	};

	const componentDidMount = () => {
		API.job
			.select(id)
			.then(({ data }) => {
				setState((prevState) => ({
					...prevState,
					...data,
					loaded: true,
				}));

				document.title = data.title;
			})
			.catch();
	};

	useEffect(componentDidMount, []);

	return loaded ? (
		<>
			<MediaQuery minWidth={992}>
				<div className="spa-page spa-job">
					<div className="actions">
						<div className="container">
							<Link
								to={`/search?category=${category?.slug}`}
								className="category"
							>
								<img
									src={category?.icon}
									alt={category?.title}
								/>

								{category?.title}
							</Link>

							{bookmarked ? (
								<Icons.Saved
									className="bookmark gray"
									onClick={() => bookmark(id)}
								/>
							) : (
								<Icons.SaveTick
									className="bookmark"
									onClick={() => bookmark(id)}
								/>
							)}
						</div>
					</div>
					<div className="content">
						<div className="container">
							<div className="media">
								<img
									src={cover?.url}
									className="cover"
								/>
								<img
									src={avatar?.url}
									className="logo"
								/>
							</div>
							<h1 className="heading">{title}</h1>
							<h3 className="name">{ceo}</h3>

							<div className="stats">
								<div className="rate">
									<div className="wrap">
										<ul>
											{[...Array(5)].map((_, index) => (
												<li
													key={index}
													onClick={() => handleRating(index + 1)}
												>
													{index < rating?.userScore ? (
														<Icons.Star doutone="true" />
													) : (
														<Icons.Star />
													)}
												</li>
											))}
										</ul>
										<span>
											<span className="score">{rating?.score}</span>
											{` ${Resources.from} ${rating?.participantsCount} ${Resources.score}`}
										</span>
									</div>
								</div>
								<div className="discount">
									<div className="wrap">
										<Icons.PercentCircle doutone="true" />
										<span>
											{`${Resources.discount}: ${discount.raw || 0} ${
												Resources.percent
											}`}
										</span>
									</div>
								</div>
							</div>

							<ul className="list">
								<li>
									<Icons.Clock />
									<span className="title">{`${Resources.clock} ${Resources.working}:`}</span>
									<span className="text">{workTime}</span>
								</li>
								{phoneNumbers &&
									phoneNumbers.map((o, i) => (
										<li key={i}>
											<Icons.Calling />

											<span className="title">{`${Resources.number} ${
												o.type === Types.phoneNumber.mobile
													? Resources.mobile
													: o.type === Types.phoneNumber.phone
													? Resources.phone
													: Resources.fax
											}:`}</span>
											<span className="text">{o.number}</span>
										</li>
									))}
								{!!websiteUrl && (
									<li>
										<Icons.Global />

										<span className="title">{`${Resources.website}:`}</span>
										<a
											href={websiteUrl}
											className="text"
											target="_blank"
											rel="noopener noreferrer"
										>
											{websiteUrl}
										</a>
									</li>
								)}
								{!!instagramUrl && (
									<li>
										<Icons.Instagram />

										<span className="title">{`${Resources.instagram}:`}</span>
										<a
											href={instagramUrl}
											className="text"
											target="_blank"
											rel="noopener noreferrer"
										>
											{instagramUrl}
										</a>
									</li>
								)}
								<li>
									<Icons.Location />

									<span className="title">{`${Resources.city}:`}</span>
									<span className="text">{`${city.name} (${province.name})`}</span>
								</li>
								<li>
									<Icons.Location />

									<span className="title">{`${Resources.address}:`}</span>
									<span className="text">{address}</span>
								</li>
							</ul>

							<div className="desc">
								<h4 className="title">
									<Icons.NoteText />
									{Resources.description}
								</h4>
								<div
									dangerouslySetInnerHTML={{
										__html: description?.replace(/\n/g, "<br />"),
									}}
									className="text"
								/>
							</div>

							<Map
								latitude={latitude}
								longitude={longitude}
								dragging={false}
							/>
						</div>
					</div>
				</div>
			</MediaQuery>
			<MediaQuery maxWidth={992}>
				<div className="pwa-header pwa-header-job">
					<div className="container">
						<Icons.ArrowRight
							className="icon back"
							onClick={() => navigate(-1)}
						/>
						<h1 className="heading">{title}</h1>
						{bookmarked ? (
							<Icons.Saved
								className="icon bookmark gray"
								onClick={() => bookmark(id)}
							/>
						) : (
							<Icons.SaveTick
								className="icon bookmark"
								onClick={() => bookmark(id)}
							/>
						)}
					</div>
				</div>
				<div className="pwa-page pwa-job">
					<div className="container">
						<div className="media">
							<img
								src={cover?.url}
								className="cover"
							/>
							<img
								src={avatar?.url}
								className="logo"
							/>
						</div>
						<h3 className="name">{ceo}</h3>

						<div className="stats">
							<div className="rate">
								<div className="wrap">
									<ul>
										{[...Array(5)].map((_, index) => (
											<li
												key={index}
												onClick={() => handleRating(index + 1)}
											>
												{index < rating?.userScore ? (
													<Icons.Star doutone="true" />
												) : (
													<Icons.Star />
												)}
											</li>
										))}
									</ul>
									<span>
										<span className="score">{rating?.score}</span>
										{` ${Resources.from} ${rating?.participantsCount} ${Resources.score}`}
									</span>
								</div>
							</div>
							<div className="discount">
								<div className="wrap">
									<Icons.PercentCircle doutone="true" />
									<span>
										{`${Resources.discount}: ${discount?.raw} ${Resources.percent}`}
									</span>
								</div>
							</div>
						</div>

						<div className="category-wrapper">
							<Link
								to={`/jobs?category=${category?.slug}`}
								className="category"
							>
								<img
									src={category?.icon}
									alt={category?.title}
								/>

								{category?.title}
							</Link>
						</div>

						<ul className="list">
							<li>
								<Icons.Clock />
								<span className="title">{`${Resources.clock} ${Resources.working}:`}</span>
								<span className="text">{workTime}</span>
							</li>
							{phoneNumbers &&
								phoneNumbers?.map((o, i) => (
									<li key={i}>
										<Icons.Calling />
										<span className="title">{`${Resources.number} ${
											o.type === Types.phoneNumber.mobile
												? Resources.mobile
												: o.type === Types.phoneNumber.phone
												? Resources.phone
												: Resources.fax
										}:`}</span>

										<Link
											to={`tel:${o?.number}`}
											target="_blank"
											rel="noopener noreferrer"
											className="support"
										>
											<span className="text">{o.number}</span>
										</Link>
									</li>
								))}
							{!!websiteUrl && (
								<li>
									<Icons.Global />

									<span className="title">{`${Resources.website}:`}</span>
									<a
										href={websiteUrl}
										className="text"
										target="_blank"
										rel="noopener noreferrer"
									>
										{websiteUrl}
									</a>
								</li>
							)}
							{!!instagramUrl && (
								<li>
									<Icons.Instagram />

									<span className="title">{`${Resources.instagram}:`}</span>
									<a
										href={instagramUrl}
										className="text"
										target="_blank"
										rel="noopener noreferrer"
									>
										{instagramUrl}
									</a>
								</li>
							)}
							<li>
								<Icons.Location />

								<span className="title">{`${Resources.city}:`}</span>
								<span className="text">{`${city?.name} (${province?.name})`}</span>
							</li>
						</ul>
						<div className="desc">
							<h4 className="title">
								<Icons.Location />
								{Resources.address}
							</h4>
							<div className="text">{address}</div>
						</div>
						<div className="desc">
							<h4 className="title">
								<Icons.NoteText />
								{Resources.description}
							</h4>
							<div
								dangerouslySetInnerHTML={{
									__html: description?.replace(/\n/g, "<br />"),
								}}
								className="text"
							/>
						</div>

						<Map
							latitude={latitude}
							longitude={longitude}
						/>
					</div>
				</div>
			</MediaQuery>
		</>
	) : (
		<Spin className="page-loading" />
	);
};

export default connect((state) => {
	return {
		user: state.user,
	};
})(Component);
